import { useMenuContext } from '../MenuContext';
import { MENU_CLOSED_WIDTH, MENU_OPEN_WIDTH } from '../sidebar/components/SidebarMenuContainer';

export default function useMenuWidth() {
  const [menuState] = useMenuContext();
  return menuState === 'open' ? MENU_OPEN_WIDTH : MENU_CLOSED_WIDTH;
}
